<template>
  <navigation-item-single
    class="navigation-item"
    :navigation-item="navigationItem"
    v-if="!navigationItem.subItems || !navigationItem.subItems.length"
  />
  <navigation-item-group
    class="navigation-item"
    :navigation-item="navigationItem"
    v-else
  />
</template>

<script>
import NavigationItemSingle from "Components/NavigationDrawer/components/NavigationItemSingle";
import NavigationItemGroup from "Components/NavigationDrawer/components/NavigationItemGroup";
export default {
  name: "NavigationItem",
  props: {
    navigationItem: {
      type: Object,
      required: true,
    },
  },
  components: { NavigationItemGroup, NavigationItemSingle },
};
</script>

<style lang="scss">
.navigation-item {
  .v-list-group--sub-group.v-list-group--active,
  .v-list-item__icon.v-list-group__header__prepend-icon,
  .v-icon {
    transform: none !important;
  }
}
</style>
